import {Store} from '@ngrx/store';
import {Router} from '@angular/router';
import {Component, OnInit, ElementRef} from '@angular/core';

// Rxjs
import {Observable} from 'rxjs/Observable';

// Reducers
import * as Auth from '../../../../auth/actions/auth.actions';
import * as fromAuth from '../../../../auth/reducers';
import * as fromCore from '../../../../core/reducers';
import * as Notifications from '../../../../core/actions/notification.actions';

// Pipes
import {OrderAlphabeticalPipe} from '../../../pipes/order-by/order-alphabetical.pipe';

@Component({
  selector: 'notification-dropdown',
  templateUrl: './notification-dropdown.component.html',
  styleUrls: ['./notification-dropdown.component.scss'],
  host: {'(document:click)': 'onClick($event)'}
})
export class NotificationDropdownComponent implements OnInit {

  // Public variables
  public dropdownOpened: boolean = false;
  public notifications: any[] = [];
  public unRead: number = 0;

  // Auth Token
  private authToken: string = '';
  private storeSubscription;

  // Public Observables
  public currentLang$: Observable<string> = this.coreStore.select(state => state.core.ui.currentLanguage);
  public userNotifications$: Observable<any> = this.coreStore.select(state => state.core.notification.userNotification);

  constructor(private _eref: ElementRef,
              private router: Router,
              private authStore: Store<fromAuth.State>,
              private coreStore: Store<fromCore.State>,
              private orderAlphabeticalPipe: OrderAlphabeticalPipe) {
  }

  ngOnInit() {
    this.storeSubscription = this.authStore.select(state => state.auth.login.token).subscribe(token => {
      this.authToken = token;
    });
    this.coreStore.dispatch(new Notifications.GetUserNotifications());
    this.coreStore.dispatch(new Notifications.CheckUserNotifications());

    this.userNotifications$.subscribe(notifications => {
      if (notifications) {
        this.unRead = notifications.unRead;
        this.notifications = this.orderAlphabeticalPipe.transform(notifications.notifications.filter(n => n.message !== null), 'creationDate', false);
      }
    });
  }

  // Navigate to Notification
  toNotification(id) {
    const url = this.router.url.split('/');
    if (id) this.router.navigate([url[1], 'notifications', id]);
    else this.router.navigate([url[1], 'notifications']);
    this.dropdownOpened = false;
  }

  // On element click
  onClick(event) {
    if (!this._eref.nativeElement.contains(event.target) && this.dropdownOpened) this.dropdownOpened = false;
  }

  // Logout
  onLogout() {
    this.authStore.dispatch(new Auth.Logout());
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/header-bar/notification-dropdown/notification-dropdown.component.ts